import { shade, rgba } from "polished";
import BrandingStream from "@irati/brand/streams/branding";
import maxWidthMedia, { minWidthMedia } from "./media";
import { updateLegacyBrand } from "./colors";
import { hoverRaise } from "./css/animations";
// Colors that are manipulated / used multiple times in theme
var perkboxBlue = "#0496FF";
var darkGrey = "#3D3D36";
var SHADE_MODIFIER = 0.8;
var HOVER_MODIFIER = 0.5;
var DARK_MODIFIER = 0.2;
var SHADOW_MODIFIER = 0.17;
var dropShadowGrey = rgba(darkGrey, SHADOW_MODIFIER);
setTimeout(function () {
    BrandingStream.subscribe(function (branding) {
        if (branding) {
            var _a = makeBrand(branding), defaultColor = _a.default, shadeColor = _a.shade, dark = _a.dark, hover = _a.hover;
            var brand = {
                default: defaultColor,
                shade: shadeColor,
                dark: dark,
                hover: hover,
                textColour: branding.textColour,
                primaryColour: branding.primaryColour
            };
            mainTheme.colors.brand = brand;
            updateLegacyBrand(brand);
        }
    });
});
var makeBrand = function (branding) {
    var brandColor = branding.primaryColour || perkboxBlue;
    return {
        default: brandColor,
        shade: "" + shade(SHADE_MODIFIER, brandColor),
        dark: "" + shade(DARK_MODIFIER, brandColor),
        hover: "" + shade(HOVER_MODIFIER, brandColor)
    };
};
var mainTheme = {
    mediaQueries: {
        maxWidthMedia: maxWidthMedia,
        minWidthMedia: minWidthMedia
    },
    colorFunctions: {
        // @todo: remove this + change usage in `packages/irati/web/tour/src/components/styled.ts` to use pallet colours
        rgba: rgba
    },
    colors: {
        success: "#00BDB3",
        error: "#B30000",
        fontColor: darkGrey,
        tooltip: "#1EBCB2",
        brand: {
            default: perkboxBlue,
            shade: "" + shade(SHADE_MODIFIER, perkboxBlue),
            dark: "" + shade(DARK_MODIFIER, perkboxBlue),
            hover: "" + shade(HOVER_MODIFIER, perkboxBlue)
        },
        perkbox: {
            blue: perkboxBlue,
            darkBlue: "#00678E",
            greenBlue: "#21A0A0"
        },
        products: {
            insights: "#21A0A0",
            medical: "#1EBCB2",
            perks: perkboxBlue,
            recognition: "#EE6352"
        },
        greys: {
            white: "#FFFFFF",
            lightest: "#F7F7F7",
            graphGrey: "#EFEFEF",
            light: "#E0E0E0",
            mediumLight: "#C5C5C5",
            medium: "#AAAAAA",
            mediumDark: "#666565",
            dark: darkGrey,
            black: "#000000",
            disabled: "#E9E9E9",
            disabledText: "#888888",
            dropShadowGrey: dropShadowGrey
        },
        callToAction: {
            default: "#FAD600",
            hover: "#F8DF4A",
            pressed: "#DFBB33"
        },
        border: {
            greyPrimary: "#D0AB3D",
            greySecondary: "#D0AB3D"
        },
        // ComponentLibrary Assets below
        primary1_600: "#007AD2",
        primary1: "#0496FF",
        primary1_200: "#81CAFF",
        primary1_100: "#B3DFFF",
        primary1_50: "#DAEFFF",
        primary2: "#21295C",
        primary2_200: "#9094AD",
        primary2_100: "#BCBECE",
        primary2_50: "#DEDFE7",
        secondary1: "#3DCCC7",
        secondary1_200: "#9EE5E3",
        secondary1_100: "#C4EFEE",
        secondary1_50: "#E2F8F7",
        secondary2: "#028090",
        secondary2_200: "#80BFC7",
        secondary2_100: "#B3D8DD",
        secondary2_50: "#D9ECEF",
        tertiary: {
            g_400: "#00BD9D",
            g_200: "#73D3C4",
            b_400: "#1F59D5",
            b_200: "#88A7E5",
            r_400: "#DE3434",
            r_200: "#E89495",
            y_400: "#F9BC14",
            y_200: "#F6D885",
            o_400: "#F97814",
            o_200: "#F6B685",
            p_400: "#FF4270",
            p_200: "#F99BB3",
            v_400: "#41AECF",
            v_200: "#8FCEE0",
            j_400: "#52489C",
            j_200: "#AAA6CE",
            i_400: "#8352E1",
            i_200: "#BBA3EC",
            f_400: "#C140AF",
            f_200: "#D99AD2"
        },
        utility: {
            ink: "#3C3C3C",
            subdued: "#98A1A4",
            contrast: "#5C5C5C",
            highlight: "#F1F1F1",
            white: "#FFFFFF",
            azure: "#E8F1F2"
        }
    },
    shadows: {
        low: "1px 2px 5px 0 rgba(0,0,0,0.1)",
        mid: "1px 3px 10px 0 rgba(0,0,0,0.1)",
        high: "1px 3px 20px 0 rgba(0,0,0,0.1)",
        focus: "0 0 4px 0 rgba(4,150,255,0.8)",
        above: {
            low: "-1px -2px 5px 0 rgba(0,0,0,0.1)",
            mid: "-1px -3px 10px 0 rgba(0,0,0,0.1)",
            high: "-1px -3px 20px 0 rgba(0,0,0,0.1)"
        },
        inset: {
            low: "inset 1px 2px 5px 0 rgba(0,0,0,0.1)",
            mid: "inset 1px 3px 10px 0 rgba(0,0,0,0.1)",
            high: "inset 1px 3px 20px 0 rgba(0,0,0,0.1)"
        }
    },
    spacing: {
        stepSize: 8,
        half: "4px",
        one: "8px",
        oneAndHalf: "12px",
        two: "16px",
        three: "24px",
        four: "32px",
        five: "40px",
        six: "48px",
        seven: "56px",
        eight: "64px",
        nine: "72px",
        ten: "80px"
    },
    font: {
        light: "LatoLight, sans-serif",
        default: "Lato, sans-serif",
        semibold: "LatoSemibold, sans-serif",
        bold: "LatoBold, sans-serif"
    },
    border: {
        radius: "2px"
    },
    animations: {
        hover: hoverRaise
    }
};
export default mainTheme;
